angular.module('tf.directives')

    .directive('tfIcon', function($window) {
        return {
            restrict    :'E',
            replace     :true,
            template    :'<div ng-include="\'../../img/icons/flat/group.svg\'" class="icon"></div>',
            scope       :{
              icon      : '@'
            },
            link        : function(scope, element, attrs) {

            }
        };
    });